import { useTranslation } from 'react-i18next'
import { TimelineItem } from '../state/types'
import { clockTime } from '../util/activity'
import { Markdown } from './Markdown'

interface AnswerCardProps {
  /** The trailing status items that make up the final answer (see splitTimeline). */
  items: TimelineItem[]
}

/** The run's answer. The service streams the answer as consecutive assistant text blocks, so they
 *  are joined back into one markdown document rather than rendered as separate rows. */
export function AnswerCard({ items }: Readonly<AnswerCardProps>) {
  const { t } = useTranslation()
  if (items.length === 0) return null

  const source = items
    .map((i) => (i.kind === 'status' ? i.text : ''))
    .filter(Boolean)
    .join('\n\n')
  const at = items[items.length - 1].at
  const time = clockTime(at)

  return (
    <section className="copilot-answer" data-testid="copilot-answer">
      <span className="copilot-answer__eyebrow">{t('copilot.answer.eyebrow')}</span>
      <div className="copilot-answer__card">
        <Markdown source={source} />
        <div className="copilot-answer__meta" data-testid="copilot-answer-meta">
          {time}
        </div>
      </div>
    </section>
  )
}
